import {useState } from "react";
import { MenuItem, Tooltip, IconButton, Menu,} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { CiEdit } from "react-icons/ci";
import CommonDeleteDialog from "../../common/CommonDelete";

import { Offcanvas } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { DataGrid } from "@mui/x-data-grid";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { CustomNoRowsOverlay } from "../../common/OverlayGrid";
import { Box } from "@mui/system";
import { CommonAddIssue } from "../../common/Issue/CommonAddIssue";
import { useTheme } from "../../../ThemeContext";
import { usePersistentFilter } from "../../../assets/hooks/usePersistentFilter";
import IssueBoard from "../issues/IssueBoard";
import Loader from "../../common/Loader";
import { CiViewList } from "react-icons/ci";
import { MdViewQuilt } from "react-icons/md";



const MilestoneTaskListIssue = ({ MilestonetaskIssue, fetchMilestonetaskIssue }) => {
  const { isDarkMode } = useTheme();
  const [viewMode, setViewMode] = usePersistentFilter("milestoneIssueDetailViewMode", "list");
  const [loading, setLoading] = useState(false);
  const { id: taskId, project_id } = useParams();
  // console.log("project_id :", project_id, taskId);
  const [showProject, setShowProject] = useState(false);
  const handleShowProject = () => setShowProject(true); // Open filter
  const { reset } = useForm();
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10});
  const loginUser = useSelector((state) => state.selectOptions?.loginUserName);
  const { role: login_user_role } = loginUser;
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const openMenu = Boolean(anchorEl);
  const [editData, setEditData] = useState(null);
  const handleMenuClick = (event, row) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = (event) => {
    if (event) event.stopPropagation();
    setAnchorEl(null);
  };

  const handleEditIssue = (event) => {
    event.stopPropagation();
    setEditData(selectedRow);
    setShowProject(true);
    handleMenuClose();
  };

  const columns = [
    {
      field: "actions",
      headerName: "Action",
      width: 100,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%" }}>
          <IconButton
            onClick={(e) => handleMenuClick(e, params.row)}
            size="small"
            style={{ padding: "10px", marginBottom: "10px" }}
          >
            <MoreVertIcon fontSize="small" />
          </IconButton>
        </div>
      ),
    },
    { field: "issue_id", headerName: "ID", width: 150 },
    { field: "title", headerName: "Issue Name", width: 200 },
    { field: "reporter", headerName: "Reporter", width: 150 },
    {
      field: "current_status_name",
      headerName: "Status",
      width: 150,
      renderCell: (params) => {
        const color = params.row.status_colour;
        const value = params.value;
        return (
          <p
            style={{
              color: color,
            }}
          >
            {value}
          </p>
        );
      },
    },
    { field: "added_at", headerName: "Created Time", width: 150 },
    { field: "assignee", headerName: "Assignee", width: 150 },
    {
      field: "priority_name",
      headerName: "Priority",
      width: 150,
      renderCell: (params) => {
        const color = params.row.priority_colour;
        const value = params.value;
        return (
          <p
            style={{
              color: color,
            }}
          >
            {value}
          </p>
        );
      },
    },
    {
      field: "severity_name",
      headerName: "Severity",
      width: 150,
      renderCell: (params) => {
        const color = params.row.severity_colour;
        const value = params.value;
        return (
          <p
            style={{
              color: color,
            }}
          >
            {value}
          </p>
        );
      },
    },
    { field: "due_date", headerName: "Due Date", width: 150 },
  ];



  return (
    <>
      <Offcanvas
        show={showProject}
        onHide={() => setShowProject(false)}
        placement="end"
        style={{ width: "50%" }}
      >
        {/* {showFilter && ( */}
        <Offcanvas.Body className="p-0">
          <CommonAddIssue
            onClear={() => reset()} // Resets to initial values
            onCancel={() => setShowProject(false)}
            // Issues={Issues}
            fetchIssues={fetchMilestonetaskIssue}
            path="milestones/task/issue"
            taskId={taskId}
            project_id={project_id}
            isTaskDetail={true}
          />
        </Offcanvas.Body>
        {/* )} */}
      </Offcanvas>

      <Box
        className="d-flex justify-content-between align-items-center"
        sx={{
          border: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
          borderRadius: "6px",
          padding: "12px 16px",
          marginBottom: "12px",
          backgroundColor: isDarkMode ? "transparent" : "#fff",
          marginTop: "10px"
        }}
      >
        <div className="d-flex align-items-center" style={{ gap: "10px" }}>
          <Tooltip title="Table View">
            <IconButton
              onClick={() => setViewMode("list")}
              sx={{
                backgroundColor: viewMode === "list" ? "rgba(18, 183, 159, 0.1)" : "transparent",
                color: viewMode === "list" ? "rgba(18, 183, 159, 1)" : "#626161",
                border: viewMode === "list" ? "1.5px solid rgba(18, 183, 159, 0.6)" : "1.5px solid #d0d0d0",
                borderRadius: "4px",
                height: "32px",
                width: "75px",
                gap: "4px",
                fontSize: "13px",
                fontWeight: 500,
                "&:hover": {
                  backgroundColor: viewMode === "list" ? "rgba(18, 183, 159, 0.2)" : "rgba(0, 0, 0, 0.04)",
                },
              }}
            >
              <CiViewList size={18} />
              Table
            </IconButton>
          </Tooltip>
          
          <Tooltip title="Board View">
            <IconButton
              onClick={() => setViewMode("board")}
              sx={{
                backgroundColor: viewMode === "board" ? "rgba(18, 183, 159, 0.1)" : "transparent",
                color: viewMode === "board" ? "rgba(18, 183, 159, 1)" : "#626161",
                border: viewMode === "board" ? "1.5px solid rgba(18, 183, 159, 0.6)" : "1.5px solid #d0d0d0",
                borderRadius: "4px",
                height: "32px",
                width: "75px",
                gap: "4px",
                fontSize: "13px",
                fontWeight: 500,
                "&:hover": {
                  backgroundColor: viewMode === "board" ? "rgba(18, 183, 159, 0.2)" : "rgba(0, 0, 0, 0.04)",
                },
              }}
            >
              <MdViewQuilt size={18} />
              Board
            </IconButton>
          </Tooltip>
        </div>

        {login_user_role !== "CLIENT" && (
          <button className="add_btn" onClick={handleShowProject}>
            Add Issues
          </button>
        )}
      </Box>

      <div style={{ width: "100%" }}>
        {loading ? (
          <Loader />
        ) : (
          <Box sx={{ height: (MilestonetaskIssue === undefined || MilestonetaskIssue.length === 0) ? 300 : "auto" }}>
            <div className="h-auto">
              {viewMode === "list" ? (
                <DataGrid
                  rows={MilestonetaskIssue || []}
                  columns={columns}
                  pageSizeOptions={[10, 20, 30, 40]}
                  pagination
                  paginationModel={paginationModel}
                  onPaginationModelChange={setPaginationModel}
                  slots={{ noRowsOverlay: CustomNoRowsOverlay }}
                  getRowId={(row) => row.issue_id}
                />
              ) : (
                <IssueBoard
                  allIssues={(MilestonetaskIssue || []).map(i => ({
                    ...i,
                    id: i.id || i.issue_id
                  }))}
                  onRefresh={fetchMilestonetaskIssue}
                  loading={loading}
                />
              )}
            </div>
          </Box>
        )}
      </div>
      
      <Menu
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleMenuClose}
        onClick={(e) => e.stopPropagation()}
      >
        <MenuItem onClick={handleEditIssue}>
          <CiEdit className="me-2" color="blue" />
          Edit Issue
        </MenuItem>
        <CommonDeleteDialog
          name="Issue"
          refetchList={fetchMilestonetaskIssue}
          handleListClose={handleMenuClose}
          url="issue/delete"
          id={selectedRow?.issue_id}
          statusName={selectedRow?.title}
          logHours={selectedRow?.log_hours}
        />
      </Menu>
    </>
  );
};

export default MilestoneTaskListIssue;
